export const LOGIN_REQ = "LOGIN_REQ";
export const LOGIN_SUCC = "LOGIN_SUCC";
export const LOGIN_FAIL = "LOGIN_FAIL";

